import { useQuery, gql } from "@apollo/client"

const useStudentsMissingHomeworks = (vars = {}, options = {fetchPolicy: 'no-cache'}) => {
    const userQuery = `
        id
        firstName
        lastName
        avatar
        studentInfo {
            parents {
                parentUserId
                managePayments
                manageApprovals
                firstName
                lastName
            }
        }
    `
    return useQuery(
        gql`
            query {
                studentsHomeworks {
                    homework {
                        ${userQuery}
                        tasksForWidget {
                            id
                            title
                            educator {
                                firstName
                                lastName
                            }
                            substitute {
                                firstName
                                lastName
                            }
                            endDate
                            service {
                                name
                            }
                            topic {
                            id
                            name
                            }
                        }
                    }
                    general {
                        ${userQuery}
                        tasksForWidget {
                            id
                            title
                            educator {
                                firstName
                                lastName
                            }
                            substitute {
                                firstName
                                lastName
                            }
                            endDate
                        }
                    }
                }
            }
        `,{
            variables: vars,
            ...options
        }
    )
}

export default useStudentsMissingHomeworks